export const unsafeUrlMessage = '지원하지 않는 접근방식입니다.'

/** 통합배송지에 저장가능한 배송지 갯수. 저장된 배송지만 카운트, 최근배송지는 카운트 하지 않음. */
export const maxAddressBookCount = 15
export const maxAddressBookExceededMessage =
    '저장가능한 배송지 개수를 초과하였습니다. 배송지를 삭제하고 새로 등록해주세요.'

export const zipCodeSearchKeyordMinLength = 2
export const zipCodeSearchKeyordMinLengthMessage = '두 글자 이상의 주소명을 입력해주세요'

export const DeliveryManagerInitializeFailCode = {
    MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE: 'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE',
    MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PRODUCT_ORDER_STATUS:
        'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PRODUCT_ORDER_STATUS',
    MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PLACE_ORDER_STATUS:
        'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PLACE_ORDER_STATUS',
    MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_DELIVERY_METHOD:
        'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_DELIVERY_METHOD',
    MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_SENDER_UNMODIFIABLE_STATE:
        'MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_SENDER_UNMODIFIABLE_STATE',
    MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_RECEIVER_ALREADY_ACCEPTED:
        'MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_RECEIVER_ALREADY_ACCEPTED',
    INVALID_ORDER_NO: 'INVALID_ORDER_NO',
}
type DeliveryManagerInitializeFailCodeType = Constant<typeof DeliveryManagerInitializeFailCode>

export const DeliveryManagerInitializeFailMessage: Record<DeliveryManagerInitializeFailCodeType, string> = {
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE]:
        '배송지를 변경할 수 있는 상품이 없습니다.',
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PRODUCT_ORDER_STATUS]:
        '결제완료 상태에서만 배송지 변경이 가능합니다.',
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PLACE_ORDER_STATUS]:
        '결제완료 상태에서만 배송지 변경이 가능합니다.',
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_DELIVERY_METHOD]:
        '배송되지 않는 상품입니다.',
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_SENDER_UNMODIFIABLE_STATE]:
        '선물 받는 사람만 배송지를 변경할 수 있습니다.',
    [DeliveryManagerInitializeFailCode.MODIFY_ORDER_DELIVERY_ADDRESS_GIFTING_RECEIVER_ALREADY_ACCEPTED]:
        '수락한 선물 주문은 배송지를 변경할 수 없습니다.',
    [DeliveryManagerInitializeFailCode.INVALID_ORDER_NO]: '유효하지 않은 주문번호입니다.',
}

const ChangeDeliveryRequestFailCode = {
    ONE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER: 'MODIFY_ORDER_DELIVERY_ADDRESS_MERCHANT_UNMODIFIABLE_DELIVERY_PLACE',
    MULTIPLE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER:
        'MODIFY_ORDER_DELIVERY_ADDRESS_MULTIPLE_MERCHANT_UNMODIFIABLE_DELIVERY_PLACE',
    DELIVERY_FEE_CHANGE: 'MODIFY_ORDER_DELIVERY_ADDRESS_ORDER_DELIVERY_AREA_CHANGED',
    UNMODIFIABLE_ORDER_STATUS: 'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_PRODUCT_ORDER_STATUS',
    UNMODIFIABLE_DELIVERY_METHOD: 'MODIFY_ORDER_DELIVERY_ADDRESS_UNMODIFIABLE_DELIVERY_METHOD',
    ARRIVAL_GUARANTEE_PRODUCT_ORDER_UNMODIFIABLE:
        'MODIFY_ORDER_DELIVERY_ADDRESS_ARRIVAL_GUARANTEE_PRODUCT_ORDER_UNMODIFIABLE',
    ARRIVAL_GUARANTEE_PRODUCT_ORDER_FAILED: 'MODIFY_ORDER_DELIVERY_ADDRESS_ARRIVAL_GUARANTEE_PRODUCT_ORDER_FAILED',
    ORDER_DELIVERY_ADDRESS_DEPRECATED_ZIP_CODE: 'ORDER_DELIVERY_ADDRESS_DEPRECATED_ZIP_CODE',
    FAIL_ADDRESS: 'CHECK_SMARTSTORE_PRODUCT_STOCK_UNAVAILABLE_ADDRESS',
    PERSONAL_CUSTOMS_CODE_INPUT: 'PERSONAL_CUSTOMS_CODE_INPUT',
    PERSONAL_CUSTOMS_CODE_INPUT_FAIL: 'PERSONAL_CUSTOMS_CODE_INPUT_FAIL',
}

export const ChangeDeliveryRequestFailMessage: Record<string, string> = {
    [ChangeDeliveryRequestFailCode.ONE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER]:
        '배송정보를 변경할 수 없도록 설정한 판매자가 포함되어 있습니다. 판매자에게 직접 연락하여 주시기 바랍니다.',
    [ChangeDeliveryRequestFailCode.MULTIPLE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER]:
        '배송정보를 변경할 수 없도록 설정한 판매자가 포함되어 있습니다. 판매자에게 직접 연락하여 주시기 바랍니다.',
    [ChangeDeliveryRequestFailCode.DELIVERY_FEE_CHANGE]:
        '도서산간/일반지역 간 배송지 변경은 배송 비용이 변동될 수 있으므로 판매자에게 문의하거나 새로 주문해주세요.',
    [ChangeDeliveryRequestFailCode.UNMODIFIABLE_ORDER_STATUS]:
        '배송지 정보 수정이 불가합니다. 주문상태를 확인해주세요.',
    [ChangeDeliveryRequestFailCode.UNMODIFIABLE_DELIVERY_METHOD]:
        '배송지 정보 수정이 불가합니다. 주문상태를 확인해주세요.',
    [ChangeDeliveryRequestFailCode.ARRIVAL_GUARANTEE_PRODUCT_ORDER_UNMODIFIABLE]:
        '배송지 정보 수정이 불가합니다. 주문상태를 확인해주세요.',
    [ChangeDeliveryRequestFailCode.ARRIVAL_GUARANTEE_PRODUCT_ORDER_FAILED]:
        '배송지 정보 수정이 불가합니다. 주문상태를 확인해주세요.',
    [ChangeDeliveryRequestFailCode.ORDER_DELIVERY_ADDRESS_DEPRECATED_ZIP_CODE]:
        '선택하신 배송지 우편번호가 폐지되어 사용 불가합니다. 배송지를 수정해주세요.',
    [ChangeDeliveryRequestFailCode.FAIL_ADDRESS]:
        '선택한 주소는 N배송 상품의 구매가 불가능한 주소입니다. 다른 주소를 선택해주세요.',
    [ChangeDeliveryRequestFailCode.PERSONAL_CUSTOMS_CODE_INPUT]:
        '다시 확인해주세요. 받는 분의 이름, 연락처, 우편번호, 통관부호가 관세청에 등록된 정보와 모두 일치해야 합니다.',
    [ChangeDeliveryRequestFailCode.PERSONAL_CUSTOMS_CODE_INPUT_FAIL]: 'P로 시작하는 12자리 숫자로 입력해주세요.',
}

/** 에러메시지 얼럿 노출 후 deliveryManager 유지 여부. true면 deliveryManager 유지, false면 창 닫힘 */
export const ChangeDeliveryRequestFailWindowMaintain: Record<string, boolean> = {
    [ChangeDeliveryRequestFailCode.ONE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER]: false,
    [ChangeDeliveryRequestFailCode.MULTIPLE_MERCHANT_UNMODIFIABLE_DELIVERY_ORDER]: false,
    [ChangeDeliveryRequestFailCode.DELIVERY_FEE_CHANGE]: false,
    [ChangeDeliveryRequestFailCode.UNMODIFIABLE_ORDER_STATUS]: false,
    [ChangeDeliveryRequestFailCode.UNMODIFIABLE_DELIVERY_METHOD]: false,
    [ChangeDeliveryRequestFailCode.ARRIVAL_GUARANTEE_PRODUCT_ORDER_UNMODIFIABLE]: false,
    [ChangeDeliveryRequestFailCode.ARRIVAL_GUARANTEE_PRODUCT_ORDER_FAILED]: false,
    [ChangeDeliveryRequestFailCode.ORDER_DELIVERY_ADDRESS_DEPRECATED_ZIP_CODE]: true,
    [ChangeDeliveryRequestFailCode.PERSONAL_CUSTOMS_CODE_INPUT]: true,
    [ChangeDeliveryRequestFailCode.FAIL_ADDRESS]: true,
}

export type DefaultBadge = '집' | '회사' | '학교' | '친구' | '가족'
export type CustomBadge = '직접입력'
export type Badge = DefaultBadge | CustomBadge
export const DefaultBadges: DefaultBadge[] = ['집', '회사', '학교', '친구', '가족']
export const Badges: Badge[] = [...DefaultBadges, '직접입력']

/** 배송지변경창 SCENE. 컴포넌트 조건부 렌더링에 사용. */
export const DELIVERY_MANAGE_SCENE = {
    /** 스토어가 초기화되기 전 타입 */
    INITIAL: 'INITIAL',
    /** 배송지 목록 (주문서에서 인입) */
    LIST: 'LIST',
    /** 배송정보 변경 (주문완료 에서 인입) */
    CHANGE: 'CHANGE',
    /** 배송지 편집 */
    FORM: 'FORM',
    /** 우편번호 검색 */
    SEARCH: 'SEARCH',
    /** 우편번호 검색 결과 */
    RESULT: 'RESULT',
    /** 선택한 우편번호 검색 결과에 상세주소 입력 */
    DETAIL_ADDRESS: 'DETAIL_ADDRESS',
} as const
export type DeliveryManagerSceneType = Constant<typeof DELIVERY_MANAGE_SCENE>

/** 우편번호 검색결과 관련 constant 모음 */
export const ZipcodeSearch = {
    /** 페이지당 최대 노출 가능한 우편번호 검색결과 */
    LIST_MAX_LENGTH_PER_PAGE: 15,
    /** 검색 결과 갯수 노출 최대치 */
    LIST_MAX_LENGTH: 500,
    /** 검색 결과 페이지네이션 노출 최대치 */
    LIST_MAX_PAGINATION_LENGTH: 5,
}
